import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import InviteesShareBreakdown from '../../components/make-purchase/invitees-share-breakdown';

import {
  getCurrentPurchase,
  getOrganizerMembership,
  getCommittedMemberships,
} from '../../selectors/purchase-selector';
import {
  getCurrentUser,
} from '../../selectors/user-selector';
import Membership from '../../lib/membership';
import {
  showRemoveModal,
  SHARED_NAMESPACE,
} from '../../actions';

class InviteesShareBreakdownContainer extends Component {
  constructor(props) {
    super(props);
    this.onRemoveMember = this.onRemoveMember.bind(this);
  }

  onRemoveMember(membership) {
    this.props.showRemoveModal({ memberships: [membership] });
  }

  render() {
    return (
      <InviteesShareBreakdown
        purchase={this.props.purchase}
        memberships={this.props.memberships}
        projectedMemberships={this.props.projectedMemberships}
        user={this.props.user}
        organizerMembership={this.props.organizerMembership}
        onRemoveMember={this.onRemoveMember}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const committedMemberships = getCommittedMemberships(state);
  const orgMembership = getOrganizerMembership(state);

  const projectedMemberships = get(state.projections, `${SHARED_NAMESPACE}.memberships`, {});
  const invitees = committedMemberships.filter(m => orgMembership.id !== m.id);
  const projectedCommittedMemberships = Membership.mergeWithProjection(invitees, projectedMemberships);

  return {
    purchase: getCurrentPurchase(state),
    memberships: projectedCommittedMemberships,
    projectedMemberships,
    user: getCurrentUser(state),
    organizerMembership: orgMembership,
  };
};

const actions = {
  showRemoveModal,
};

export default connect(mapStateToProps, actions)(InviteesShareBreakdownContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/make-purchase/invitees-share-breakdown.container.js